import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import Snackbar from 'material-ui/Snackbar';
import { EmptyState, PageHeader, QueueWrap, Spinner } from 'components';
import { connect } from 'react-redux';
import convertPost from '../../helpers/convertPost';
import { getBuckets } from 'redux/modules/contentLibraryContent';
import { loadOrganizationQueues } from 'redux/modules/queues';
import { populateComposebox } from 'redux/modules/composeboxForm';
import { parseLink } from 'redux/modules/parsedLinks';
import PublishingWrapper from './PublishingWrapper';

var getUrls = require('get-urls');

var Queues = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    categories: state.contentLibraryContent.categories,
    organization: state.organization.current,
    queues: state.queues[orgId] || [],
    loadingQueues: state.queues.loadingQueues,
    theme: state.theme
  };
}, {
  getBuckets: getBuckets,
  loadOrganizationQueues: loadOrganizationQueues,
  populateComposebox: populateComposebox
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Queues, _Component);

  var _super = _createSuper(Queues);

  function Queues(props) {
    var _this;

    _classCallCheck(this, Queues);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setSnackbarMessage", function (message) {
      _this.setState({
        snackbarMessage: message
      });
    });

    _this.state = {};
    return _this;
  }

  _createClass(Queues, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadOrganizationQueues(this.props.organization.id);

      if (!this.props.categories.length) {
        this.props.getBuckets();
      }
    }
  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(PublishingWrapper, {
        params: this.props.params,
        organization: this.props.organization,
        innerLayoutStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Queues"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Queues",
        style: {
          paddingLeft: 36,
          marginBottom: 24
        }
      }), !this.props.loadingQueues ? this.props.queues && this.props.queues.length > 0 ? /*#__PURE__*/React.createElement(QueueWrap, {
        router: this.props.router
      }) : /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Subscribe to Content",
        buttonOnClick: function buttonOnClick() {
          _this2.props.router.push("/org/".concat(_this2.props.organization.id, "/content"));
        },
        text: "You do not have any Content Queues yet.",
        iconName: "fa fa-calendar-minus-o",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }) : /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        style: {
          position: 'relative'
        }
      })));
    }
  }]);

  return Queues;
}(Component)) || _class);
export { Queues as default };